@if (urmEnabled && mode==='icon') {
  @if (loading) {
    <mat-progress-spinner [diameter]="15" color="accent" mode="indeterminate"></mat-progress-spinner>
  }
  @if (!loading && cautions) {
    <mat-icon color="accent" fontIcon="fa-exclamation-triangle" fontSet="fas"
    matTooltip="There are cautions associated with the Property."></mat-icon>
  }
  @if (!loading && error) {
    <mat-icon color="accent" fontIcon="fa-unlink"
    fontSet="fas" matTooltip="Connection to URM could not be established"></mat-icon>
  }
}
@if (urmEnabled && mode==='verbose') {
  @if (loading) {
    <mat-progress-bar></mat-progress-bar>
  }
  @if (error) {
    <span>Error connecting to Property Information Service</span>
  }
  @if (!loading) {
<!--    <span>({{ tenantCautions.length }} tenant cautions, {{ propertyCautions.length }} property-->
<!--      cautions)</span>-->
    <mat-list>
      @for (tenantCaution of tenantCautions; track tenantCaution) {
        <urm-tenant-caution-list-item
        [caution]="tenantCaution"></urm-tenant-caution-list-item>
      }
      @for (propertyCaution of propertyCautions; track propertyCaution) {
        <urm-property-caution-list-item
        [caution]="propertyCaution"></urm-property-caution-list-item>
      }
    </mat-list>
  }
}
